<script setup lang="ts">
import { ConfirmDialog, Icon, Toast } from '@jervis/ui';
</script>

<template>
  <Toast position="top-right" />
  <!--
    ConfirmDialog's own `icon` render path is class-based (no text-content slot props), so a
    per-call PrimeIcons string can't become a Material Symbols ligature there. Every
    `useConfirm().require()` call site in the app uses this for a destructive/attention
    confirmation, so a single fixed Material Symbol here (rather than a per-call icon) covers all
    of them consistently.
  -->
  <ConfirmDialog>
    <template #icon>
      <Icon name="warning" :size="20" />
    </template>
  </ConfirmDialog>
  <RouterView />
</template>
